import { combineReducers } from "redux"
import cart from "./cart"
import settings from "./settings"


export default combineReducers({
    cart,
    settings
})